import Communications from "@profilog/misc/communications/components/old/Communications";
import AppSettings from "../../app/AppSettings";

export default function Communication() {
    return <Communications medicalSubjectId={AppSettings.user.userMedicalSubjectId} isProfi={false} />;
}
